import { render, staticRenderFns } from "./TablesHome.vue?vue&type=template&id=015b1d8b&scoped=true"
import script from "./TablesHome.vue?vue&type=script&lang=js"
export * from "./TablesHome.vue?vue&type=script&lang=js"
import style0 from "./TablesHome.vue?vue&type=style&index=0&id=015b1d8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015b1d8b",
  null
  
)

export default component.exports